import React from 'react';
import { motion } from 'framer-motion';
import './Layout.css';
const InfoDemo = () => {
  return (
    <div style={{ height: '100%', textAlign: 'center' }}>
      <p className='lh-5' style={{ fontWeight: 'bold' }}>
        INFO LOGIN
      </p>
      <p className='lh-5'>Username : user-rapat</p>
      <p className='lh-5'>Password : 18784</p>
    </div>
  );
};

export default InfoDemo;
